// extracted by mini-css-extract-plugin
export default {"container":"ProgressRing_container__NeRWn","bar":"ProgressRing_bar__cLh1+"};